module.exports = __webpack_public_path__ + "img/illustration.61ef34dc.png";